module.exports = __webpack_public_path__ + "static/media/BelmontOffice3.f3cfbb75.png";